import { render } from "./RuleWithInactiveCampaignSwitchOnModalContent.vue?vue&type=template&id=9170f29a"
import script from "./RuleWithInactiveCampaignSwitchOnModalContent.vue?vue&type=script&lang=js"
export * from "./RuleWithInactiveCampaignSwitchOnModalContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleWithInactiveCampaignSwitchOnModalContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9170f29a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9170f29a', __exports__)) {
    api.reload('9170f29a', __exports__)
  }
  
  module.hot.accept("./RuleWithInactiveCampaignSwitchOnModalContent.vue?vue&type=template&id=9170f29a", () => {
    api.rerender('9170f29a', render)
  })

}


export default __exports__